import headshot from "assets/about/about.jpg";
import whitewave from "assets/whitewave.png";

export default function Articles() {
  return (
    <div className="flex flex-wrap mb-20 justify-center lg:justify-start">
      {articles.map((props) => (
        <ArticlePreviewTemplate {...props} />
      ))}
      <Podcast />
      {articles2.map((props) => (
        <ArticlePreviewTemplate {...props} />
      ))}
    </div>
  );
}

function ArticlePreviewTemplate({ link, logoAlt, logo, bgLink, bgAlt, text }) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="mt-10 mr-4 flex flex-nowrap max-w-[300px] h-[200px] relative hover:scale-[0.98]"
    >
      <img
        src={bgLink}
        alt={logoAlt}
        className="z-10 h-full w-full absolute opacity-60 rounded-lg object-cover"
      />
      <div className="flex flex-col z-20 mt-10 p-4">
        <img src={logo} alt={bgAlt} className="my-2 w-[300px]" />
        <div className="text-xs text-center">{text}</div>
      </div>
    </a>
  );
}

function Podcast() {
  return (
    <iframe
      height="200px"
      width="100%"
      className="mt-10 w-[300px] mr-4"
      title="professional podcast network interview with violet moon from moonflamelove"
      frameBorder="no"
      scrolling="no"
      seamless=""
      src="https://player.simplecast.com/68c6ce68-17c3-4684-ba01-320fa21e20fe?dark=false"
    ></iframe>
  );
}

const articles = [
  {
    link: "https://shoutouthtx.com/meet-violet-moon-creator-dance-artist-choreographer/",
    logo: "https://cdn.shoutouthtx.com/wp-content/uploads/2024/04/cropped-logo-black.png",
    logoAlt: "",
    bgLink: headshot,
    bgAlt: "",
    text: "Meet Violet Moon | Creator, Dance Artist, & Choreographer",
  },
  {
    link: "https://www.whitewavedance.org/copy-of-program-2-3",
    logo: whitewave,
    logoAlt: "",
    bgLink:
      "https://nfg-sofun.s3.amazonaws.com/uploads/event/photo/79353/poster_board_2025_Solo_Duo_Post_Card(2).jpg",
    bgAlt: "",
    text: "Meet Violet Moon | Creator, Dance Artist, & Choreographer",
  },
  {
    link: "https://thedancedish.org/dance-source-houston-announces-barnstorm-dance-fest-2025/",
    logo: "https://thedancedish.org/wp-content/uploads/2013/08/dishnew300.png",
    logoAlt: "",
    bgLink:
      "https://thedancedish.org/wp-content/uploads/2025/03/bdf-2025-slider-1536x502.png",
    bgAlt: "",
    text: "Dance Source Houston Announces Barnstorm Dance Fest 2025",
  },
  {
    link: "https://thedancedish.org/mind-the-gap-32-behind-the-works/",
    logo: "https://thedancedish.org/wp-content/uploads/2013/08/dishnew300.png",
    logoAlt: "",
    // bgLink: "https://thedancedish.org/wp-content/uploads/2024/11/VMoon.jpeg",
    bgLink:
      "https://cdn.shoutouthtx.com/wp-content/uploads/2025/04/c-1743468361504-1743468360895_violet_moon__ha_5515-2048x1365.jpg",
    bgAlt: "",
    text: "Mind The Gap 32 – Behind The Works",
  },
];
const articles2 = [
  {
    link: "https://thedancedish.org/mind-the-gap-turns-25-with-a-new-lineup-of-dancemakers/",
    logo: "https://thedancedish.org/wp-content/uploads/2013/08/dishnew300.png",
    logoAlt: "",
    bgLink:
      "https://cdn.shoutouthtx.com/wp-content/uploads/2025/04/c-1743468298949-1743468298646_violet_moon_dsh-mtg-32-violet-moon-photographer-lynn-lane-web-88.jpg",
    bgAlt: "",
    text: "Mind The Gap Turns 25 With A New Lineup of Dancemakers",
  },
  {
    link: "https://thedancedish.org/dance-source-houston-presents-mind-the-gap-xxv/",
    logo: "https://thedancedish.org/wp-content/uploads/2013/08/dishnew300.png",
    logoAlt: "",
    bgLink:
      "https://thedancedish.org/wp-content/uploads/2023/07/DSH-MTG-23-Violet-Moon-Photographer-Lynn-Lane-WEB-43-450x300.jpg",
    bgAlt: "",
    text: "Dance Source Houston Presents Mind The Gap XXV",
  },
  {
    link: "https://thedancedish.org/dance-source-houston-announces-barnstorm-dance-fest-2024/",
    logo: "https://thedancedish.org/wp-content/uploads/2013/08/dishnew300.png",
    logoAlt: "",
    bgLink:
      "https://thedancedish.org/wp-content/uploads/2024/03/BS_Web_Banner_02-1536x1024.png",
    bgAlt: "",
    text: "Dance Source Houston Announces Barnstorm Dance Fest 2024",
  },

  {
    link: "https://thedancedish.org/choreographers-mind-the-gap-for-the-first-time-in-2023/",
    logo: "https://thedancedish.org/wp-content/uploads/2013/08/dishnew300.png",
    logoAlt: "",
    bgLink: "https://thedancedish.org/wp-content/uploads/2023/02/3.jpg",
    bgAlt: "",
    text: "Choreographers Mind The Gap For The First Time In 2023",
  },
];
